var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p20" },
    [
      _c("titleBar", { attrs: { title: "我的流程" } }),
      _c(
        "div",
        { staticClass: "mt10" },
        [
          _c(
            "van-grid",
            { attrs: { "column-num": 2 } },
            _vm._l(_vm.flowsTemplateList, function (item, i) {
              return _c(
                "van-grid-item",
                {
                  key: i,
                  on: {
                    click: function ($event) {
                      return _vm.change(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "avatar" }, [
                    _vm._v(_vm._s(item.templateName.substring(0, 1))),
                  ]),
                  _c("div", { staticClass: "first-title m-t-20" }, [
                    _vm._v(_vm._s(item.templateName)),
                  ]),
                  _c("div", { staticClass: "second-title m-t-20" }, [
                    _vm._v(_vm._s(item.remark)),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }